import React from 'react';
import MuiChip from '@mui/material/Chip';

const Chip = (props) => <MuiChip {...props} />;

export default Chip;
